import { Action } from '@ngrx/store';
import { AddressData, ContractData, PersonalData } from '../../models/cancel-contract-data.model';
/** CancelContractDataActionType */
export enum CancelContractDataActionType {
    PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
    ADRESS_INFORMATION = 'ADRESS_INFORMATION',
    CONTRACT_INFORMATION = 'CONTRACT_INFORMATION',
}
/** SetPersonalDataAction */
export class SetPersonalDataAction implements Action {
    /** CancelContractDataActionType */
    public readonly type = CancelContractDataActionType.PERSONAL_INFORMATION;
    // constructor contains payload
    public constructor (public payload: {
         /** personalData */
        personalData: PersonalData,
    }) { }
}
/** SetAddressDataAction */
export class SetAddressDataAction implements Action {
    /** CancelContractDataActionType */
    public readonly type = CancelContractDataActionType.ADRESS_INFORMATION ;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
         /** personalData */
         AddressData: AddressData,
    }) { }
}
/** SetAddressDataAction */
export class SetContractDataAction implements Action {
    /** CancelContractDataActionType */
    public readonly type = CancelContractDataActionType.CONTRACT_INFORMATION ;
    public constructor (public payload: {
         /** personalData */
         ContractData: ContractData,
    }) { }
}
/** CancelContractDataAction */
export type CancelContractDataAction = SetPersonalDataAction | SetAddressDataAction | SetContractDataAction;
